import { Dispatch, SetStateAction } from 'react';
import { SecondaryButton } from '../../../../components/SecondaryButton';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';

interface SearchesTypesProps {
  setSearchByCpfModalShow: Dispatch<SetStateAction<boolean>>;
  setSearchByCodeModalShow: Dispatch<SetStateAction<boolean>>;
  setSearchByNameModalShow: Dispatch<SetStateAction<boolean>>;
  setSearchByRegistrationModalShow: Dispatch<SetStateAction<boolean>>;
  setSearchByPeriodModalShow: Dispatch<SetStateAction<boolean>>;
  setSearchByWorkplaceModalShow: Dispatch<SetStateAction<boolean>>;
  setSearchByFileModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function SearchesTypes({
  setSearchByCpfModalShow,
  setSearchByCodeModalShow,
  setSearchByNameModalShow,
  setSearchByRegistrationModalShow,
  setSearchByPeriodModalShow,
  setSearchByWorkplaceModalShow,
  setSearchByFileModalShow,
}: SearchesTypesProps) {
  const { permissions } = useGetGeneralAppData();
  const routingFilePermissions = permissions.find((x) => x.codPag === 7);

  return (
    <>
      <SecondaryButton onClick={() => setSearchByCpfModalShow(true)}>
              Por CPF
      </SecondaryButton>
      <SecondaryButton onClick={() => setSearchByCodeModalShow(true)}>
              Por Código da Consulta
      </SecondaryButton>
      <SecondaryButton onClick={() => setSearchByNameModalShow(true)}>
              Por Nome
      </SecondaryButton>
      <SecondaryButton onClick={() => setSearchByRegistrationModalShow(true)}>
              Por Matrícula
      </SecondaryButton>
      <SecondaryButton onClick={() => setSearchByPeriodModalShow(true)}>
              Por período
      </SecondaryButton>
      <SecondaryButton onClick={() => setSearchByWorkplaceModalShow(true)}>
              Por Local de trabalho
      </SecondaryButton>
      {routingFilePermissions?.vizualizar && (
        <SecondaryButton onClick={() => setSearchByFileModalShow(true)}>
                Por Arquivo
        </SecondaryButton>
      )}
    </>
  );
}
